module.exports = __webpack_public_path__ + "static/media/new_business_incubator.eaa52541.png";